var map = {
	"./anamensi.svg": 15829,
	"./cuore.svg": 19413,
	"./esame_obiettivo.svg": 97072,
	"./logo.png": 1250,
	"./runner.svg": 92781,
	"./stomaco.svg": 63177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30119;